import { parseDomain } from '@wix/domains-serverless-interface';
import { useCallback } from 'react';
import DomainTruncationHelpers, { ELLIPSIS_BUFFER_PX } from '../DomainTruncationHelpers';
/**
 * Custom hook to handle domain truncation logic
 */
export const useDomainTruncation = _ref => {
  let {
    domainStr,
    measureTextWidth
  } = _ref;
  const domain = parseDomain(domainStr);

  // Calculates the optimal truncated domain based on available width
  const calculateTruncatedDomain = useCallback((text, availableWidth) => {
    if (!text) {
      return text;
    }
    const parts = parseDomain(text);
    if (parts.error) {
      return text;
    }
    const tld = parts.tld;
    const sld = parts.sld || '';
    const subdomain = parts.subdomain;

    // Check if full domain fits
    const fullWidth = measureTextWidth(text);
    if (fullWidth <= availableWidth) {
      return text;
    }

    // Measure component parts
    const tldPart = `.${tld}`;
    const tldWidth = measureTextWidth(tldPart);
    let subdomainWidth = 0;
    let subdomainPart = '';
    if (subdomain) {
      subdomainPart = `${subdomain}.`;
      subdomainWidth = measureTextWidth(subdomainPart);
    }
    const ellipsisWidth = measureTextWidth('...');

    // Always preserve the full subdomain
    const sldAvailableWidth = availableWidth - tldWidth - subdomainWidth - ellipsisWidth - ELLIPSIS_BUFFER_PX;

    // If extremely constrained, show minimal representation
    if (sldAvailableWidth <= 0) {
      return DomainTruncationHelpers.createMinimalDomainRepresentation(sld, subdomain, tldPart);
    }

    // Find optimal character counts for front and back
    const {
      frontChars,
      backChars
    } = DomainTruncationHelpers.findOptimalFit(sld, subdomainPart, tldPart, availableWidth, measureTextWidth);
    return DomainTruncationHelpers.createTruncatedDomainText(sld, subdomainPart, tldPart, frontChars, backChars);
  }, [measureTextWidth]);
  return {
    calculateTruncatedDomain,
    domain
  };
};
export default useDomainTruncation;
//# sourceMappingURL=useDomainTruncation.js.map